import React, {useState, useEffect, useContext} from "react";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";

import PrintHeader from "../common/PrintHeader";

import Img from "../../common/Img";

import Chart from "./_Chart";
import PaymentsList from "./_PaymentsList";
import SummaryCard from "./_SummaryCard";
import BenefitsList from "./_BenefitList";
import GeneralSalaryChart from "./_GeneralSalaryChart";
import FinancePastBalance from "./_PastBalance";
import {
    formatPrintAmount,
    formatPrintMoney,
    getTeacherProfileRow,
    resolveTeacherHalfYearData,
} from "../financePrintUtils";

const TeacherSalaryReport = (props) => {
    const {teacher_id, activeYear} = props.match.params;

    const [data, updateData] = useState([]);
    const [balance, setBalance] = useState([]);

    const [filteredData, updateFilteredData] = useState({});

    let printHeadTexts = [
        'معاونیت امور اداری و مالی',
        'مدیریت مالی'
    ];

    let title = 'گزارشات';


    useEffect(async () => {
        const ac = new AbortController();
        requestData();
        return () => ac.abort();
    }, []);

    const resolveHalfYearData = resolveTeacherHalfYearData;

    const requestData = async () => {
        let query = `teachers/${teacher_id}/salary`;

        await db.getAll(query).then(({data}) => {
            updateData(data);

            // if activeYear is provided then show data for that year
            // else show all data
            if (activeYear) {
                updateFilteredData(resolveHalfYearData(data?.data, activeYear))
            } else {
                // combine all payments and benefits for general report
                let allData = {payments: [], benefits: []}
                for (let record of data?.data) {
                    allData.payments = [...allData.payments, ...record.payments];
                    allData.benefits = [...allData.benefits, ...record.benefits];
                }
                updateFilteredData({...data?.data[0], ...allData})
            }
        });

        await db.getAll(`teachers/${teacher_id}/balance`)
            .then(({ data: { data } }) => {setBalance(data[0])});
    };

    const teacherProfile = getTeacherProfileRow(data?.data, filteredData);

    return (
        <main className="main-print-wrapper teacher-salary-report-print">
            <PrintHeader
                title={title}
                subtitle={!!activeYear ? filteredData?.half_year : "تمام نیمسال ها"}
                date={' '}
                printHeadTexts={printHeadTexts}
            />

            <div style={{display: "grid", gap: "10px", marginBottom: "5px"}}>
                <div className="print-finance-top-row" style={{display: "grid", gridTemplateColumns: "auto 70%", gap: "10px"}}>
                    <div className="report-summary-area white-background-with-border">

                        {/* switch between chart and summary */}
                        {activeYear
                            ?  <SummaryCard title={lbl.Summary} data={data}/>
                            :  <GeneralSalaryChart title={lbl.Summary} data={data}/>}

                    </div>
                    <div className="white-background-with-border print-finance-profile-panel"
                         style={{
                             display: "grid",
                             gridTemplateColumns: "auto 60%",
                             alignItems: "center",
                             justifyItems: "center",
                             padding: "20px 0"
                         }}>
                        <div className="overall-summary">
                            <div className="wrapper">
                                <p>{lbl.OverallBalance}</p>
                                <h2 className="print-ltr-amount">{formatPrintMoney(data?.summary?.overall_balance)}</h2>
                            </div>
                        </div>
                        <div className="print-finance-profile-row" style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            gap: "20px",
                            alignContent: "flex-end",
                            placeItems: "center",
                            width: "100%",
                            paddingRight: "50px",
                        }}>
                            <div className="std-profile rounded">
                                <div className="wrapper">
                                    <Img src={data?.summary?.teacher_photo}/>
                                </div>
                            </div>

                            <div>
                                <div className="wrapper" style={{textAlign: "right"}}>
                                    <h3>{teacherProfile.teacher_name || data?.summary?.name || data?.summary?.teacher_name || ''}</h3>
                                    <p>{teacherProfile.faculty || filteredData?.faculty || data?.summary?.faculty || ''}</p>
                                    <p>{teacherProfile.teacher_phone || filteredData?.teacher_phone || data?.summary?.teacher_phone || data?.summary?.phone || ''}</p>
                                    <p>{teacherProfile.aria_id || data?.summary?.aria_id || filteredData?.aria_id || ''}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* hide this chart in general report */}
                {activeYear ? <div className="white-background-with-border">
                    <Chart data={filteredData}/>
                </div> : null}
            </div>

            {/* only show in general report */}
            {!activeYear ? <div><p style={{color: "var(--blue)", textAlign: "center"}}>{lbl.OpeningBalance}</p>
                <FinancePastBalance balance={balance && balance}/>
            </div> : null}
            <p style={{color: "var(--blue)", textAlign: "center"}}>{lbl.Payments}</p>
            <PaymentsList activeYear={filteredData}/>

            <p style={{color: "var(--blue)", textAlign: "center"}}>{lbl.Benefits}</p>
            <BenefitsList activeYear={filteredData}/>

            <div style={{display: "grid", gridTemplateColumns: "auto auto auto", paddingTop: "50px"}}>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء تایید کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء پرداخت کننده</p>
                        </div>
                    </div>
                </div>
                <div className="print-identity">
                    <div className="print-signature-area">
                        <div className="wrapper" style={{width: "80%"}}>
                            <hr/>
                            <p>نام و امضاء گیرنده</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default TeacherSalaryReport;
